export var ClientType;
(function (ClientType) {
    ClientType["api"] = "api";
    ClientType["pigeon"] = "pigeon";
})(ClientType || (ClientType = {}));
